// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"c21f6bbf","239":"b378691b","455":"aa4dcc62","977":"3217ea08"}[chunkId] + ".chunk.js";
};